function normalizeInsert(insert: any) {
  if (typeof insert === "string") {
    let s = insert;
    if (s.endsWith("\r\n")) s = s.slice(0, -2);
    else if (s.endsWith("\n") || s.endsWith("\r")) s = s.slice(0, -1);
    return s;
  }

  return insert ?? null;
}

export function deltaEqualsByContent(d1: any, d2: any): boolean {
  if (d1 === d2) return true;
  if (!d1?.ops || !d2?.ops) return false;

  const a = d1.ops;
  const b = d2.ops;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; i++) {
    const insA = normalizeInsert(a[i]?.insert);
    const insB = normalizeInsert(b[i]?.insert);

    if (JSON.stringify(insA) !== JSON.stringify(insB)) return false;
  }

  return true;
}
